import React from 'react';
import {useScrollSpy} from '@di-shared/features/common/ScrollSpyProvider';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export default function (): JSX.Element {
  const {t} = useInferableTranslation();
  const {sectionTo, getSectionProps, getSectionHeaderProps} = useScrollSpy();
  const TABS = [
    {value: 'driving', label: t('ctn_knowing_data_mytrips_title')},
    {value: 'score', label: t('ctn_knowing_data_driving_saftey_score_title')},
    {value: 'diag', label: t('ctn_knowing_data_diagnostics_title')},
  ];

  return (
    <>
      <div
        className="tabbar_txt tabbar_sticky"
        role="tablist"
      >
        <div className="inner">
          {TABS.map((tab) => (
            <button
              key={tab.value}
              type="button"
              className="tabbar_item body_large_r"
              {...getSectionHeaderProps(tab.value)}
              onClick={() => sectionTo(tab.value)}
              id={`${tab.value}_tab`}
              role="tab"
              aria-controls={`${tab.value}_tabpanel`}
            >
              <span className="txt">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="tab_content">
        {TABS[0]?.value && (
          <section
            className="section data_explore_section"
            {...getSectionProps(TABS[0].value)}
          >
            <h3 className="title_xsmall_b">{TABS[0].label}</h3>
            <div
              className="data_explore_content"
              role="group"
            >
              <p
                className="data_explore_desc"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('msg_knowing_data_mytrips_01')}
              </p>
              <div className="section_container">
                <div className="data_header">
                  <h5 className="data_title">{t('ctn_knowing_data_mytrips_collected_01')}</h5>
                </div>
                <ul
                  className="data_list"
                  role="list"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  <li className="data_item">{t('ctn_knowing_data_mytrips_collected_02')}</li>
                  <li className="data_item">{t('ctn_knowing_data_mytrips_collected_03')}</li>
                  <li className="data_item">{t('ctn_knowing_data_mytrips_collected_04')}</li>
                  <li className="data_item">{t('ctn_knowing_data_mytrips_collected_05')}</li>
                </ul>
                <div className="data_header">
                  <h5 className="data_title">{t('ctn_knowing_data_mytrips_processed_01')}</h5>
                </div>
                <ul
                  className="data_list"
                  role="list"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  <li className="data_item">{t('ctn_knowing_data_mytrips_processed_02')}</li>
                  <li className="data_item">{t('ctn_knowing_data_mytrips_processed_03')}</li>
                  <li className="data_item">{t('ctn_knowing_data_mytrips_processed_04')}</li>
                </ul>
              </div>
            </div>
          </section>
        )}
        {TABS[1]?.value && (
          <>
            <div className="divider divider_thick" />
            <section
              className="section data_explore_section"
              {...getSectionProps(TABS[1].value)}
            >
              <h3 className="title_xsmall_b">{TABS[1].label}</h3>
              <div
                className="data_explore_content"
                role="group"
              >
                <p
                  className="data_explore_desc"
                  style={{whiteSpace: 'pre-wrap'}}
                >
                  {t('msg_knowing_data_driving_saftey_score_01')}
                </p>
                <div className="section_container">
                  <div className="data_header">
                    <h5 className="data_title">{t('ctn_knowing_data_driving_saftey_score_collected_01')}</h5>
                  </div>
                  <ul
                    className="data_list"
                    role="list"
                    style={{whiteSpace: 'pre-wrap'}}
                  >
                    <li className="data_item">{t('ctn_knowing_data_driving_saftey_score_collected_02')}</li>
                    <li className="data_item">{t('ctn_knowing_data_driving_saftey_score_collected_03')}</li>
                  </ul>
                  <div className="data_header">
                    <h5 className="data_title">{t('ctn_knowing_data_driving_saftey_score_processed_01')}</h5>
                  </div>
                  <ul
                    className="data_list"
                    role="list"
                    style={{whiteSpace: 'pre-wrap'}}
                  >
                    <li className="data_item">{t('ctn_knowing_data_driving_saftey_score_processed_02')}</li>
                    <li className="data_item">{t('ctn_knowing_data_driving_saftey_score_processed_03')}</li>
                  </ul>
                </div>
              </div>
            </section>
          </>
        )}
        {TABS[2]?.value && (
          <>
            <div className="divider divider_thick" />
            <section
              className="section data_explore_section"
              {...getSectionProps(TABS[2].value)}
            >
              <h3 className="title_xsmall_b">{TABS[2].label}</h3>

              <div className="data_explore_content">
                <h4 className="data_explore_title">{t('ctn_knowing_data_ev_battery_title_eu')}</h4>
                <p className="data_explore_desc">{t('msg_knowing_data_ev_battery_01_eu')}</p>
                <div className="section_container">
                  <div className="data_header">
                    <strong className="data_title">{t('ctn_knowing_data_ev_battery_01_eu')}</strong>
                  </div>
                  <ul className="data_list">
                    <li className="data_item">{t('ctn_knowing_data_ev_battery_collected_02_eu')}</li>
                    <li className="data_item">{t('ctn_knowing_data_ev_battery_collected_03_eu')}</li>
                    <li className="data_item">{t('ctn_knowing_data_ev_battery_collected_04_eu')}</li>
                  </ul>
                  <div className="data_header">
                    <strong className="data_title">{t('ctn_knowing_data_ev_battery_processed_01_eu')}</strong>
                  </div>
                  <ul className="data_list">
                    <li className="data_item">{t('ctn_knowing_data_ev_battery_processed_02_eu')}</li>
                    <li className="data_item">{t('ctn_knowing_data_ev_battery_processed_03_eu')}</li>
                  </ul>
                </div>
              </div>

              <div className="data_explore_content">
                <h4 className="data_explore_title">{t('ctn_knowing_data_tire_title')}</h4>
                <p className="data_explore_desc">{t('msg_knowing_data_tire_01')}</p>
                <div className="section_container">
                  <div className="data_header">
                    <strong className="data_title">{t('ctn_knowing_data_tire_collected_01')}</strong>
                  </div>
                  <ul className="data_list">
                    <li className="data_item">{t('ctn_knowing_data_tire_collected_02')}</li>
                    <li className="data_item">{t('ctn_knowing_data_tire_collected_03')}</li>
                  </ul>
                  <div className="data_header">
                    <strong className="data_title">{t('ctn_knowing_data_tire_processed_01')}</strong>
                  </div>
                  <ul className="data_list">
                    <li className="data_item">{t('ctn_knowing_data_tire_processed_02')}</li>
                  </ul>
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </>
  );
}
